import { Component, ViewChild, ElementRef, OnInit, OnDestroy } from "@angular/core";
import { FormGroup, FormControl, Validators, ValidatorFn } from "@angular/forms";
import { SharedService } from "../shared/service";
import { AccountHttpService } from "../generated/account-http.service";
import { Router, ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs";


@Component({
  templateUrl: './recover.content.html'
})
export class RecoverContent implements OnInit, OnDestroy {

  private subscription = new Subscription();

  ngOnInit(): void {
    this.subscription.add(this.route.queryParams.subscribe(queryParams => {
      this.form.controls.username.setValue(queryParams.name);
    }));
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  @ViewChild('username') private elementRef: ElementRef;

  public ngAfterViewInit(): void {
    this.elementRef.nativeElement.focus();
  }

  form = new FormGroup({
    username: new FormControl('', Validators.required),
  });

  constructor(private route: ActivatedRoute, private router: Router, public shared: SharedService, private accountHttpService: AccountHttpService) {

  }

  async submit() {
    try {
      const formValue = this.form.value;
      await this.accountHttpService.recoverPassword({ username: formValue.username }).toPromise();
      this.shared.notifySuccess(this.shared.res['#Recover password'], this.shared.res['#An email with a link to recover your password has been sent.']);
      this.router.navigate(['/']);
    } catch (e) {
      this.shared.notifyError(this.shared.res['#Recover password failed'], this.shared.res['#Recover password failed']);
    }
  }

}
